import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const TextItem = ({ data }) => {
    const payload = data.payload;
    const value = payload.value || '';

    return (
        <ListItem>
            <i className="material-icons">mode_comment</i>
            <ListItemText primary={payload.title} secondary={value} />
        </ListItem>
    );

}

export default TextItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/Text.js